import clienteAxios from '../config/clientAxios';

export const getCiegDocuments = async (categoryPath, params = {}) => {
    const response = await clienteAxios.get('cieg/documentos', {
        params: {
            category_path: categoryPath,
            ...params
        }
    });

    return response.data.documents || response.data.data || [];
};

export const getCiegDocumentCategories = async () => {
    const response = await clienteAxios.get('cieg/documentos/categorias');

    return response.data;
};

export const normalizeCiegDocument = (document) => ({
    id: document.id,
    name: document.name || document.title,
    title: document.title || document.name,
    file: document.file || document.file_path,
    file_path: document.file_path || document.file,
    image: document.image || document.image_path,
    image_path: document.image_path || document.image,
    image_url: document.image_url,
    type: document.type || document.file_type || 'PDF',
    file_type: document.file_type || document.type || 'PDF',
    category_path: document.category_path,
    display_type: document.display_type,
    metadata: document.metadata || {}
});
